var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plan-order"},[_c('app-header',{attrs:{"title":_vm.title}}),_c('studyplan-order-info',{on:{"submit":_vm.submit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }